// components/BottomNav.tsx
import { useLocation } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { profileRouteList, routeList, settingsRouteList } from "../App";
import { usePwaViewportWidth } from "../hooks/useScreenWidth";
import { BallButton, NavItem } from "../styles/Button.style";
import { Row } from "../styles/Utils";
import ArrowIcon from "./svgs/icons/Arrow.icon";
import { ProfileIcon } from "./svgs/icons/Profile.icon";
import { SettingsIcon } from "./svgs/icons/Settings.icon";

export const TopNavBar = () => {
  const theme = useTheme();
  const screenWidth = usePwaViewportWidth();
  const location = useLocation();

  const getColorFromActivity = (route: string) =>
    location.pathname.startsWith(route) ? theme.color.tertiaryLight : theme.color.primaryDark;

  const isSettingsRoute = Object.values(settingsRouteList).includes(location.pathname);
  const isProfileRoute = Object.values(profileRouteList).includes(location.pathname);

  return (
    <RootContainer $width={screenWidth}>
      <Row $gap={1}>
        <NavItem to={routeList.profile}>
          <ProfileIcon color={getColorFromActivity(routeList.profile)} />
        </NavItem>
      </Row>
      <Row $gap={1}>
        <NavItem to={routeList.settings}>
          <SettingsIcon color={getColorFromActivity(routeList.settings)} />
        </NavItem>
        {isSettingsRoute && (
          <NavItem to={routeList.settings}>
            <BallButton $position="right">
              <ArrowIcon color={theme.color.tertiaryLight} />
            </BallButton>
          </NavItem>
        )}
        {isProfileRoute && (
          <NavItem to={routeList.profile}>
            <BallButton $position="right">
              <ArrowIcon color={theme.color.tertiaryLight} />
            </BallButton>
          </NavItem>
        )}
      </Row>
    </RootContainer>
  );
};

const RootContainer = styled.nav<{
  $width: number;
  $background?: string;
}>`
  width: ${(props) => props.$width}px;
  padding-inline: ${(props) => `${props.theme.rootContainerInlinePadding}`};
  padding-top: calc(${(props) => `${props.theme.rootContainerInlinePadding}`} + env(safe-area-inset-top));
  padding-bottom: 0;
  display: flex;
  justify-content: space-between;
`;
